import { TeamGroup } from '../../../../../domain/interfaces/team-group';
import StageGroup from './stage-group/stage-group';
import { Team } from 'modules/teams/domain/interfaces/team';

type StageGroupListProps = {
  groups: TeamGroup[];
  teams: Team[];
};

const StageGroupList = ({ groups, teams }: StageGroupListProps) => {
  return (
    <div>
      {groups.map((group) => (
        <StageGroup key={group.id} group={group} teams={teams} />
      ))}
    </div>
  );
};

export default StageGroupList;
